module.exports = __webpack_public_path__ + "img/tertiary_4x4.af4c8fa0.svg";